import { buildQueries, HTTP } from "@/api/http-common";
import ENDPOINT from "@/api/endpoints";
import _cloneDeep from "lodash/cloneDeep";

export function callApiLayDanhSachVaiTro(payload, endpoint) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${endpoint}?${buildQueries(payload)}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayChiTietVaiTro(payload) {
  return HTTP({
    url: ENDPOINT.ROLE.CHI_TIET_VAI_TRO,
    method: "GET",
    params: payload
  });
}

export function callApiXoaVaiTro(payload) {
  return HTTP({
    url: ENDPOINT.ROLE.XOA_VAI_TRO,
    method: "DELETE",
    params: payload
  });
}

export function callApiTaoVaiTro(payload, endpoint) {
  return new Promise((resolve, reject) => {
    return HTTP.post(endpoint, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiCapNhatThongTinVaiTro(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.put(ENDPOINT.ROLE.CAP_NHAT_THONG_TIN_VAI_TRO, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiCapNhatQuyenTrongVaiTro(payload) {
  return HTTP({
    url: ENDPOINT.ROLE.CAP_NHAT_QUYEN_TRONG_VAI_TRO,
    method: "PUT",
    data: payload
  });
}

export function callApiCapNhatNguoiDungTrongVaiTro(payload) {
  return HTTP({
    url: ENDPOINT.ROLE.CAP_NHAT_NGUOI_DUNG_TRONG_VAI_TRO,
    method: "PUT",
    data: payload
  });
}

export function callApiLayDanhSachNguoiDung(payload, endpoint) {
  return new Promise((resolve, reject) => {
    const newPayload = _cloneDeep(payload);
    delete newPayload.id;

    return HTTP.get(
      `${endpoint}/${payload.id}/users?${buildQueries(
        newPayload,
        "UserSearch."
      )}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachNguoiDungKhongThuocVaiTro(payload, endpoint) {
  return new Promise((resolve, reject) => {
    const newPayload = _cloneDeep(payload);
    delete newPayload.id;

    return HTTP.get(
      `${endpoint}/${payload.id}/users-not-in?${buildQueries(
        newPayload,
        "UserSearch."
      )}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachVaiTroTheoApp(payload) {
  return HTTP({
    url: ENDPOINT.ROLE.DANH_SACH_VAI_TRO_THEO_APP,
    method: "GET",
    params: payload
  });
}

export function callApiLayDanhSachVaiTroKhongThuocGroup(payload) {
  return HTTP({
    url: ENDPOINT.ROLE.DANH_SACH_VAI_TRO_KHONG_THUOC_GROUP,
    method: "GET",
    params: payload
  });
}
